<template>
  <div>
    <Row>
      <i-col span="24">
        <Form :model="searchForm" ref="searchForm" inline :label-width="60">
        <FormItem label="资产编号">
          <Input v-model="searchForm.asset_id" style="min-width: 100px" />
        </FormItem>
        </FormItem>
        <FormItem :label-width="0" class="mob-align-right">
          <Button type="primary" @click="getInventorys()">搜索</Button>
          <Button style="margin-left: 8px" @click="searchReset">重置</Button>
          <Button type="primary" size="large" style="margin-left: 10px" @click="exportData" :loading="exportLoading"><Icon type="ios-download-outline"></Icon>导出报表</Button>
        </FormItem>
      </Form>
      </i-col>
      </Row>
      <Row>
       <Table
          border
          :width="1600"
          highlight-row
          ref="table"
          :loading="tableLoading"
          :data="table.data"
          :columns="table.columns">
        </Table>
        <div style="margin: 10px 0; overflow: hidden;">
          <div style="float: left;">
            当前显示 {{ table.data.length }} 条记录，总共 {{ table.count }} 条记录
          </div>
          <div style="float: right;">
            <page
              :total="table.count"
              :current="table.page"
              :page-size="table.size"
              @on-change="getInventorys"></page>
          </div>
        </div>
      </Row>
  </div>
</template>
<script>
import Tables from '_c/tables'
import { getInventoryCommodities, exportInventoryReport } from '@/api/cmdb'
import expandRow from './table-expand.vue'
import excel from '@/libs/excel'
import moment from 'moment'
export default {
  name: 'InventoryList',
  props: {
    id: Number
  },
  components: {
    Tables,
    expandRow
  },
  data () {
    return {
      exportLoading: false,
      tableLoading: false,
      table: {
        data: [],
        columns: [
          {
            type: 'expand',
            title: '',
            align: 'center',
            minWidth: 60,
            render: (h, params) => {
              return h('div', [
                h(expandRow, {
                  props: {
                    row: params.row.info.asset_info
                  }
                })
              ])
            }
          },
          {
            title: '资产编号',
            minWidth: 100,
            align: 'center',
            key: 'asset_id'
          },
          {
            title: '是否盘点',
            minWidth: 150,
            align: 'center',
            key: 'result',
            render: (h, params) => {
              const color = params.row.result === 1 ? 'error' : params.row.result === 2 ? 'success' : 'warning'
              const text = params.row.result === 1 ? '未盘' : params.row.result === 2 ? '已盘' : '未知'
              return h('Tag', {
                props: {
                  type: 'dot',
                  color: color
                }
              }, text)
            }
          },
          {
            title: '盘点人',
            minWidth: 100,
            align: 'center',
            key: 'counting_people'
          },
          {
            title: '资产名称',
            align: 'center',
            minWidth: 100,
            render: (h, params) => {
              return h('span', params.row.info.asset_info['名称'])
            }
          },
          {
            title: '资产类型',
            minWidth: 100,
            align: 'center',
            key: 'asset_type',
            render: (h, params) => {
              if (params.row.info.asset_type) {
                return h('span', params.row.info.asset_type)
              }
            }
          },
          {
            title: '关联资产',
            minWidth: 100,
            align: 'center',
            render: (h, params) => {
              return h('span', params.row.info.bind_asset)
            }
          },
          {
            title: '采购日期',
            minWidth: 130,
            align: 'center',
            key: 'buy_time',
            render: (h, params) => {
              if (params.row.info.buy_time) {
                return h('span', params.row.info.buy_time)
              }
            }
          },
          {
            title: '所属公司',
            minWidth: 130,
            align: 'center',
            key: 'company',
            render: (h, params) => {
              if (params.row.info.company) {
                return h('span', params.row.info.company)
              }
            }
          },
          {
            title: '供应商',
            key: 'supplier',
            minWidth: 100,
            align: 'center',
            render: (h, params) => {
              if (params.row.info.supplier) {
                return h('span', params.row.info.supplier)
              }
            }
          },
          {
            title: '保管人',
            minWidth: 150,
            align: 'center',
            key: 'use_person',
            render: (h, params) => {
              if (params.row.info.use_person) {
                return h('span', params.row.info.use_person)
              }
            }
          },
          {
            title: '领用时间',
            minWidth: 180,
            align: 'center',
            key: 'use_time',
            render: (h, params) => {
              if (params.row.info.use_time) {
                return h('div', moment(params.row.info.use_time).format('YYYY-MM-DD HH:mm:ss'))
              } else {
                return ''
              }
            }
          },
          {
            title: '状态',
            minWidth: 100,
            align: 'center',
            key: 'status',
            render: (h, params) => {
              return h('span', params.row.info.status)
            }
          },
          {
            title: '备注',
            align: 'center',
            minWidth: 100,
            key: 'remark',
            render: (h, params) => {
              return h('span', params.row.info.remark)
            }
          }
        ],
        count: 1,
        page: 1,
        size: 15
      },
      table_loading: false,
      searchForm: {
        asset_id: ''
      }
    }
  },
  watch: {
    id () {
      console.log(this.id)
      if (this.id) {
        this.getInventorys()
      }
    }
  },
  methods: {
    exportData () {
      this.exportLoading = true
      let params = {
        inventory_count_id: this.id
      }
      exportInventoryReport(params).then(res => {
        this.exportLoading = false
        console.log(res.data.data.data.length)
        if (res.data.data.data.length > 0) {
          // 把返回数据的utc时间转换为当地时间
          res.data.data.data.map(item => {
            item['领用时间'] = item['领用时间'] ? moment(item['领用时间']).format('YYYY-MM-DD HH:mm:ss') : ''
          })
          const params = {
            title: res.data.data.field,
            key: res.data.data.field,
            data: res.data.data.data,
            autoWidth: true,
            filename: `固定资产导出报表.csv`
          }
          console.log(params)
          excel.export_array_to_excel(params)
        } else {
          this.$Message.info('表格数据不能为空！')
        }
      }).catch(res => {
        this.exportLoading = false
      })
    },
    getInventorys (value = 1) {
      this.table.page = value
      this.table_loading = true
      let data = {
        inventory_count: this.id,
        asset_id: this.searchForm.asset_id,
        size: this.table.size,
        page: this.table.page
      }
      getInventoryCommodities(data).then(res => {
        console.log(res)
        if (res.status === 200) {
          this.table.data = res.data.results
          this.table.count = res.data.count
          this.TableLoading = false
        }
      })
    },
    searchReset () {
      this.searchForm.asset_id = ''
    }
  },
  created: function () {
  },
  mounted: function () {
    console.log(this.id)
    if (this.id) {
      this.getInventorys()
    }
  }
}
</script>

<style>
.ivu-poptip-body {
  text-align: left !important;
}
</style>
